import { DataFichaRegistro, FichaRegistro } from './../../../../models/fichaRegistro.model';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { ArchivosSubidosInterface, ArchivosSubidosResponseInterface } from 'app/models/archivos-subidos-model';
import { FichasRegistroBienesCulturales } from 'app/models/fichaRegistro.model';
import { InfoTecnicaBienMueble } from 'app/models/info-tecnica-bien-mueble.model';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { BehaviorSubject } from 'rxjs';
import { InfoUbicacion } from './tabs/ubicacion/models/ubicacion.model';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';
import { ProcedenciaInterface } from 'app/models/procedencia.model';
import { UtilsService } from 'app/modules/utils-service';
import { PutDetalleBienes } from './info-principal-bien-cultural/models/put-detalle-bienes.model';
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';

@Injectable({providedIn: 'root'})
export class DetalleBienCulturalService {
    servicios:BehaviorSubject<Tipologia[]> = new BehaviorSubject<Tipologia[]>([]);
    valor:BehaviorSubject<Tipologia[]> = new BehaviorSubject<Tipologia[]>([]);
    fichaRegistro:BehaviorSubject<DataFichaRegistro>= new BehaviorSubject<DataFichaRegistro>(null)
    bitacorasBienes = new BehaviorSubject<BitacoraActividadesInterface[]>([]);
    elementosVinculadosBienes: BehaviorSubject<ElementosVinculadosInterface[]> = new BehaviorSubject<ElementosVinculadosInterface[]>([])
    private drawerOpen$ = new BehaviorSubject<boolean>(false);

    get servicios$(){
        return this.servicios.asObservable()
    }

    get valor$(){
        return this.valor.asObservable()
    }

    get fichaRegisto$(){
        return this.fichaRegistro.asObservable()
    }

    get bitacoraBienes$(){
        return this.bitacorasBienes.asObservable();
    }

    get elementosVinculadosBienes$(){
        return this.elementosVinculadosBienes.asObservable()
    }
    
    get isDrawerOpen$() {
        return this.drawerOpen$.asObservable();
      }

    openDrawer() {
        this.drawerOpen$.next(true);
    }

    closeDrawer() {
        this.drawerOpen$.next(false);
    }

    constructor(private apiService:ApiService, private utilsService:UtilsService) { }

    actualizarInformacionTecnica(body: InfoTecnicaBienMueble, uu_id:string){
        const url= `/bien_cultural/paso2/${uu_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al actualizar Información Técnica.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        }) 
    }

    postGaleria(body:any, uu_id:string){
        const url= `/bien_cultural/paso3/${uu_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al Guardar imagenes de la Galeria.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getTipologiasServicio(tipologia_id:number){
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener servicios.')
                .subscribe((response:TipologiasInterface) => {
                    this.servicios.next(response[0].tipologias)
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getTipologiasValor(tipologia_id:number){
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener valores.')
                .subscribe((response:TipologiasInterface) => {
                    this.valor.next(response[0].tipologias)
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getFichaRegistro(uu_id: string): Promise<FichasRegistroBienesCulturales> {
        const url = `/bien_cultural`;
        const params = { bienCulturalUuid: uu_id };

        return new Promise((resolve, reject) => {
            this.apiService.GetMethod(url, params, 'Error al obtener información de ficha Técnica.')
                .subscribe((response: FichasRegistroBienesCulturales) => {
                    const data = response.data;
                    
                    if (data && data.length > 0) {
                        const ficha = data[0];

                        if (ficha.imagenFavorita !== 0) {
                            this.utilsService.getArchivosInternos(ficha.imagenFavorita)
                                .then((blobURL) => {
                                    ficha.blobURL = blobURL;
                                    this.fichaRegistro.next(ficha);
                                })
                                .catch(() => {
                                    this.fichaRegistro.next(ficha);
                                });
                        } else {
                            this.fichaRegistro.next(ficha);
                        }
                    }

                    resolve(response);
                }, error => {
                    reject(error);
                });
        });
    }


    actualizarUbicación(body: InfoUbicacion, uu_id:string){
        const url= `/bien_cultural/ubicacion/${uu_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al actualizar Ubicación.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        }) 
    }

    getTipologias(tipologia_id:number): Promise<Tipologia[]>{
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener tipología.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    getBitacoraBienes(_entidadUuid:string){
        const url='/bitacoras'
        const params= {entidadUuid:_entidadUuid}
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: any) => {
                    this.bitacorasBienes.next(response.data);  
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }

    putInfoProcedencia(uu_id:string, body:ProcedenciaInterface){
        const url= `/bien_cultural/procedencia/${uu_id}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, 'Error al obtener los datos.')
                .subscribe((response: any) => { 
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }

    putDetalleBienCultural(uu_id:string, body:PutDetalleBienes){
        const url= `/bien_cultural/detalle/${uu_id}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body,{},'Error al actualizar los datos.')
                .subscribe((response: any) => { 
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }

    getElementosVinculados(task_uuid: string){
            const url=`/vinculo/${task_uuid}`
            return new Promise((resolve, reject)=>{
                this.apiService.GetMethod(url, {}, 'Error al obtener los elementos vínculados.')
                    .subscribe((response: ElementosVinculadosInterface[]) => {
                        this.elementosVinculadosBienes.next(response)
                        resolve(response)                  
                    }, error => {
                        reject(true)
                    })
            })
        }
    
}